// extracted by mini-css-extract-plugin
export default {"curve":"curve_curve__X6TKH","curveDivs":"curve_curveDivs__nFzZw"};